import { User, UserAndMessage } from './User';
import { abortTracking } from '@/tmp';
import { getRequestConfigurationWithDeviceInfos } from '@/utilities/deviceInfoUtils';
import { dataLayerPushEvent } from '@/utilities/gtmUtils';
import * as Sentry from '@sentry/react';
import axios from 'axios';

// ha nincs bejelentkezve, akkor null-t adunk vissza
// undefined nem jo, mert az azt jelenti, hogy nem tudjuk, van-e session
// null-nal tudjuk, hogy nincs
export async function getUser() {
  const config = await getRequestConfigurationWithDeviceInfos(undefined);
  const url = '/api/v1.1/users/current';
  // does not throw an error if there is no session
  const result = await axios.get<UserAndMessage>(url, Object.assign({}, config, {
    validateStatus: (status: number) => status === 200 || status === 401,
  }));

  if (result.status === 200) {
    const user = result.data;
    setUpUser(user);
  }

  return result;
}

function setUpUser(user: UserAndMessage) {
  const userId = user.id;
  const userName = user.name;

  dataLayerPushEvent("login", { userid: userId });
  Sentry.setUser({ id: userId, username: userName, ip_address: "{{auto}}" });
}

type changePasswordRequest = {
  currentPassword: string;
  newPassword: string;
};

export async function changePassword(username: string, currentPassword: string, newPassword: string) {
  await loginUser({ username, password: currentPassword, rememberMe: false, isBiometricLogin: false });
  const url = '/api/v1.1/passwordreset/changepassword';
  const changePasswordPair = {
    newPassword,
    currentPassword,
  } satisfies changePasswordRequest;
  await axios.post(url, changePasswordPair);

  await logoutUser();
}

type resetPasswordRequest = {
  desiredUser: string;
  desiredEmail: string;
  lang: string;
};

export async function resetPassword(desiredUser: string, desiredEmail: string, lang: string) {
  const url = '/api/v1.1/passwordreset/sendreset';
  const resetPassword = {
    desiredUser,
    desiredEmail,
    lang,
  } satisfies resetPasswordRequest;
  await axios.post(url, resetPassword);
}

export async function logoutUser() {
  abortTracking();
  const url = '/api/v1.1/logout';
  // FIXME nem kellene ennek post-nak lennie ???
  return axios.get<void>(url);
}

export async function loginUser({ username, password, rememberMe, isBiometricLogin }: { username: string, password: string, rememberMe: boolean, isBiometricLogin: boolean }): Promise<User> {
  if (username === undefined || password === undefined) {
    throw new Error('Username and password must be provided');
  }

  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  if (rememberMe) {
    params.append("remember-me", "true");
  }

  // throws an error if invalid
  const config = await getConfig(isBiometricLogin);
  const response = await axios.post<UserAndMessage>('/api/v1.1/login', params, config);
  const user = response.data;
  setUpUser(user);
  return user;
}

async function getConfig(isBiometricLogin: boolean) {
  const config = await getRequestConfigurationWithDeviceInfos(isBiometricLogin);
  const sendUser = { sendUser: true };
  const headers = {headers: { ...config.headers, ...sendUser }};
  return Object.assign({}, headers,  {validateStatus: (status: number) => status === 200});
}
